import type { FC } from 'react';

import { type IBaseButtonProps } from './BaseButton'
import { PrimaryButtonStyled } from './styles/PrimaryButtonStyled'

export const PrimaryButton: FC<IBaseButtonProps> = PrimaryButtonStyled

PrimaryButton.displayName = 'PrimaryButton'
